<template>
  <div class="moreVideo">
    <div style="padding: 0 260px">
      <div class="breadIt">
        <span style="cursor: pointer" @click="goBack">小视频分享</span> >
        更多视频
      </div>
      <div class="moreTitle">小视频分享</div>
      <div v-if="smallVideo && smallVideo.length > 0">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, index) in smallVideo" :key="index">
            <div class="video-item" @click="player(item)">
              <div class="video">
                <img :src="item.coverUrl" class="video-cover" />
              </div>
              <div class="video-title">{{ item.title }}</div>
              <div class="video-num">浏览量：{{ item.viewCount }}</div>
              <div class="line"></div>
              <div class="item-footer">
                <div>知孝云谱</div>
                <div>{{ item.updateTime.substr(0, 10) }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="padding: 100px 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totals"
            @current-change="curChange"
            :page-size="pageSize"
            :current-page="pageNo"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="70%" @close="closeDia">
      <video
        v-if="playUrl"
        ref="video"
        width="98%"
        height="100%"
        :src="playUrl"
        :autoplay="autoplay"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { getWebsite } from "@/api/request";
import { getNewsDatebyId } from "../../api/request";
export default {
  components: {},
  data() {
    return {
      smallVideo: [],
      pageNo: 1,
      pageSize: 10,
      totals: 0,
      dialogVisible: false,
      playUrl: "",
      autoplay: true,
    };
  },
  created() {
    this.getVideos();
  },
  mounted() {},
  methods: {
    getVideos() {
      getWebsite({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: 2,
        isOut: true,
        secondType: 7,
      }).then((res) => {
        this.totals = Number(res.data.result.total);
        this.smallVideo = res.data.result.records;
      });
    },
    goBack() {
      this.$router.push({ path: "/video" }, () => {});
    },
    curChange(e) {
      this.pageNo = e;
      this.getVideos();
    },
    player(item) {
      this.dialogVisible = true;
      this.playUrl = item.videoUrl;
      getNewsDatebyId(item.id).then((res) => {});
      this.$nextTick(() => {
        this.$refs.video.play();
      });
      this.autoplay = true;
    },
    closeDia() {
      this.$nextTick(() => {
        this.$refs.video.pause();
      });
      this.autoplay = false;
    },
  },
};
</script>
<style scoped>
.breadIt {
  text-align: left;
  padding-top: 28px;
}
.moreTitle {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  padding: 52px 0;
  color: #111;
}
.moreItem {
  width: 326px;
  height: 423px;
  background: skyblue;
  margin-bottom: 32px;
}
.video-item {
  width: 326px;
  position: relative;
  text-align: left;
  border: 1px solid #eaeff5;
  cursor: pointer;
  margin-bottom: 32px;
}
.video {
  background-image: url("../../assets/record-video.png");
  background-size: cover;
  height: 244px;
  position: relative;
}
.video-cover {
  width: 195px;
  height: 122px;
  position: absolute;
  top: 53px;
  left: 65px;
}
.video-title {
  font-size: 18px;
  font-weight: 700;
  margin: 20px 20px 12px;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  height: 50px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.video-num {
  font-size: 16px;
  font-weight: 400;
  padding: 0 20px 0px;
}
.line {
  width: calc(100% - 40px);
  height: 1px;
  background: #eaeff5;
  margin: 20px;
}
.item-footer {
  display: flex;
  justify-content: space-between;
  padding: 0 20px 20px 20px;
  color: #999da6;
  line-height: 17px;
  font-size: 12px;
}
</style>
